
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Page from '@organisms/Page/Page';
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import createFallback, { oneHourInSeconds } from '@helpers/fallback';
import useCmsPage from '@hooks/useCmsPage';
import ErrorComponent from '@molecules/ErrorComponent/ErrorComponent';
const CategoryPage = ({ code }: InferGetStaticPropsType<typeof getStaticProps>) => {
    const { cmsPage, error, isLoading } = useCmsPage(undefined, 'CategoryPage', code);
    if (!isLoading && error)
        return <ErrorComponent errorCode={404}/>;
    return <Page cmsPage={cmsPage}/>;
};
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}
async function getStaticProps({ params }: GetStaticPropsContext) {
    const categories = params?.categories;
    const code = Array.isArray(categories) ? categories.join('/') : (categories as string);
    const fallback = await createFallback('CategoryPage', undefined, code);
    return {
        props: {
            fallback,
            code,
            pageType: 'CategoryPage',
        },
        revalidate: oneHourInSeconds,
    };
}
export default CategoryPage;

    async function __Next_Translate__getStaticProps__1993895198b__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sortiment/CategoryPage.tsx',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1993895198b__ as getStaticProps }
  